import Logger = require("js-logger");
import { Signal } from "signals";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import gameState from "slotworks/model/game-state";
import Record from "slotworks/model/gameplay/records/record";
import { clearElement } from "slotworks/utils/dom-utils";

export default class RecordTree {

    public select: Signal = new Signal();

    private element: HTMLDivElement;

    constructor() {
        this.draw();

        this.update();
    }

    public toggle() {
        if (this.element.parentElement) {
            canvasManager.rootNode.removeChild(this.element);
        } else {
            canvasManager.rootNode.appendChild(this.element);
        }
    }

    public update() {

        const gameplay = gameState.getCurrentGame();

        clearElement(this.element);

        const keyElement = document.createElement("div");
        keyElement.innerHTML = "🛑 = last record<br>";
        keyElement.innerHTML += "✔️/ ❌ = is branch complete<br>";
        keyElement.innerHTML += "<hr>";
        this.element.appendChild(keyElement);

        const printBranch = (record: Record, tabs: string) => {

            const lastChildLabel = record.lastChild ? "🛑" : "";
            const hasChildrenLabel = record.isBranchComplete() ? "✔️" : "❌";
            const label = `${tabs} ${record.id} ${lastChildLabel} ${hasChildrenLabel}`;

            const recordElement = document.createElement("a");
            recordElement.innerText = label;

            recordElement.style.textDecoration = "none";
            recordElement.style.whiteSpace = "pre";
            recordElement.style.color = "#ffffff";
            recordElement.style.display = "block";
            recordElement.style.cursor = "pointer";

            recordElement.onclick = () => {
                Logger.info(record);
                this.select.dispatch(record);
            };

            this.element.appendChild(recordElement);

            tabs += "    ";
            for (const child of record.children) {
                printBranch(child, tabs);
            }
        };

        printBranch(gameplay.getRootRecord(), "");

        const currentRecord = gameplay.getCurrentRecord();
        this.select.dispatch(currentRecord);

        if (gameplay.isComplete()) {
            const completeElement = document.createElement("div");
            completeElement.innerText = " 🎉 Game complete 🎉";
            this.element.appendChild(completeElement);
        }
    }

    private draw() {
        this.element = document.createElement("div");
        this.element.id = "integrationDebugger_resultTree";

        this.element.style.position = "fixed";
        this.element.style.top = this.element.style.left = "0";
        this.element.style.zIndex = "900";
        this.element.style.width = "20vw";
        this.element.style.height = "100vh";
        this.element.style.paddingTop = "5vh";
        this.element.style.paddingLeft = "3vw";
        this.element.style.pointerEvents = "all";

        this.element.style.backgroundColor = "#222";
        this.element.style.border = "solid 1px white";

        this.element.style.color = "#fff";
        this.element.style.fontSize = "20px";

        canvasManager.rootNode.appendChild(this.element);
    }
}
